// extracted by mini-css-extract-plugin
module.exports = {"tile":"tile_tile__2hPMQ","tile-set":"tile_tile-set__11sr2"};